import portfolioImg01 from "../images/portfolioImg01.png";
import portfolioImg02 from "../images/portfolioImg02.png";
import portfolioImg03 from "../images/portfolioImg03.png";
import portfolioImg04 from "../images/portfolioImg04.png";
import portfolioImg05 from "../images/portfolioImg05.png";
import portfolioImg06 from "../images/portfolioImg06.png";
import portfolioImg07 from "../images/portfolioImg07.png";


const portfolios = [
  {
    id: "01",
    imgUrl: portfolioImg01,
    category: "Backend",
    title: "Grocery Store",
    description:
      'Online grocery store built using NextJs and Sanity, a powerful backend CMS that allows us to easily manage our content and data. This app is hosted using vercel. External Api and JavaScript to create an interactive and visually appealing user interface',
    technologies: ["NextJs", "Tailwind css", "Sanity", "SanityDB"],
    siteUrl: "https://grossy.vercel.app/", 
  },
  {
    id: "02",
    imgUrl: portfolioImg02,
    category: "Frontend",
    title: "Quotes App",
    description:
      'A web application designed to display and provide thought provoking quotes to users.The app is typically built using Html, Css, External Api and JavaScript to create an interactive and visually appealing user interface',
    technologies: ["React", "Vanilla css", "External Api", "JavaScript"],
    siteUrl: "https://shai9.github.io/Solace-project/",
  },
  {
    id: "03",
    imgUrl: portfolioImg03,
    category: "Backend",
    title: "Onest",
    description:
      "A Hotel reviews app, this app is intended to be a simple example of a CRUD app built using ReactJs and Ruby on Rails",
    technologies: ["React", "Styled Components", "Ruby on Rails", "Postgresql"],
    siteUrl: "https://onest-azpw.onrender.com/",
  },
  {
    id: "04",
    imgUrl: portfolioImg04,
    category: "Frontend",
    title: "Quizzy",
    description:
      "A web application designed to display and provide thought provoking quotes to users.The app is typically built using Html, Css, External Api and JavaScript to create an interactive and visually appealing user interface",
    technologies: ["React", "Tailwind css", 'Html', 'Vanilla CSS' ],
    siteUrl: "#",
  },
  {
    id: "05",
    imgUrl: portfolioImg05,
    category: "Frontend",
    title: "Keeper",
    description:
      "A web application designed to display and provide thought provoking quotes to users.The app is typically built using Html, Css, External Api and JavaScript to create an interactive and visually appealing user interface",
    technologies: ["React", "Vanilla css", "Html", "TailwindCss", "Sass" ],
    siteUrl: "#",
  },
  {
    id: "06",
    imgUrl: portfolioImg06,
    category: "Backend",
    title: "Hackerank Clone",
    description:
      "A web application designed to display and provide thought provoking quotes to users.The app is typically built using Html, Css, External Api and JavaScript to create an interactive and visually appealing user interface",
    technologies: ["React", "Tailwind css", "Sass", "PostgreSql"],
    siteUrl: "#",
  },
  {
    id: "07",
    imgUrl: portfolioImg07,
    category: "Backend",
    title: "Project Management Website",
    description:
      "",
    technologies: ["React", "Tailwind css", "Ruby", "PostgreSql"],
    siteUrl: "#",
  },
  {
    id: "08",
    imgUrl: portfolioImg01,
    category: "Backend",
    title: "Grocery Store",
    description:
      'Online grocery store built using NextJs and Sanity, a powerful backend CMS that allows us to easily manage our content and data. This app is hosted using vercel.',
    technologies: ["NextJs", "Tailwind css", "Sanity", "SanityDB"],
    siteUrl: "https://grossy.vercel.app/",
  },
  {
    id: "09",
    imgUrl: portfolioImg02,
    category: "Frontend",
    title: "Quotes App",
    description:
      'A web application designed to display and provide thought provoking quotes to users.The app is typically built using Html, Css, External Api and JavaScript to create an interactive and visually appealing user interface',
    technologies: ["React", "Vanilla css", "External Api", "JavaScript"],
    siteUrl: "https://shai9.github.io/Solace-project/",
  },
  {
    id: "10",
    imgUrl: portfolioImg03,
    category: "Backend",
    title: "Onest",
    description:
      "A Hotel reviews app, this app is intended to be a simple example of a CRUD app built using ReactJs and Ruby on Rails",
    technologies: ["React", "Styled Components", "Ruby on Rails", "Postgresql"],
    siteUrl: "https://onest-azpw.onrender.com/",
  },
  {
    id: "11",
    imgUrl: portfolioImg04,
    category: "Frontend",
    title: "Quizzy",
    description:
      "A web application designed to display and provide thought provoking quotes to users.The app is typically built using Html, Css, External Api and JavaScript to create an interactive and visually appealing user interface",
    technologies: ["React", "Tailwind css","Html", "TailwindCss", "Sass" ],
    siteUrl: "#",
  },
  {
    id: "12",
    imgUrl: portfolioImg05,
    category: "Frontend",
    title: "Keeper",
    description:
      "A web application designed to display and provide thought provoking quotes to users.The app is typically built using Html, Css, External Api and JavaScript to create an interactive and visually appealing user interface",
    technologies: ["React", "Vanilla css", "Html", "Sass" ],
    siteUrl: "#",
  },
  {
    id: "16",
    imgUrl: portfolioImg06,
    category: "Backend",
    title: "Hackerank Clone",
    description:
      "A web application designed to display and provide thought provoking quotes to users.The app is typically built using Html, Css, External Api and JavaScript to create an interactive and visually appealing user interface",
    technologies: ["React", "Tailwind css", "Sass", "PostgreSql"],
    siteUrl: "#",
  },
  {
    id: "13",
    imgUrl: portfolioImg07,
    category: "Backend",
    title: "Project Management Website",
    description:
      "A web application designed to display and provide thought provoking quotes to users.The app is typically built using Html, Css, External Api and JavaScript to create an interactive and visually appealing user interface",
    technologies: ["React", "Tailwind css", "Ruby", "PostgreSql"],
    siteUrl: "#",
  },
];

export default portfolios;